import { TaskCenterTypes } from '@frontend/api-task-center';
import { useTranslation } from '@frontend/i18n';
import { formatPhoneNumber } from '@frontend/phone-numbers';
import { useTaskCenterStore } from '@frontend/task-center-scope';
import { Citation } from '../types';

interface SetMessageCitationProps {
  sourceId: string;
  source: Citation;
  personName?: string;
  locationId: string;
}

export const useTaskCitation = () => {
  const { t } = useTranslation('task-center');
  const { selectedTask, setSelectedTask, setTaskMode, setIsTaskCenterOpen, isTaskCenterOpen } = useTaskCenterStore([
    'setSelectedTask',
    'setTaskMode',
    'selectedTask',
    'setIsTaskCenterOpen',
    'isTaskCenterOpen',
  ]);

  const setMessageCitation = ({ sourceId, source, personName, locationId }: SetMessageCitationProps) => {
    const title = t(`Inbox: New Task ({{personTitle}})`, {
      personTitle: !!personName ? personName : formatPhoneNumber(source.phone_no) ?? 'Unknown User',
    });
    if (!!selectedTask?.sourceId) {
      // marking the selectedTask as null so that we override task the when we API fetches the updated details
      setSelectedTask(null);
    }
    setSelectedTask({
      source: TaskCenterTypes.TaskSource.SOURCE_MESSAGING,
      sourceId,
      metadata: JSON.stringify({ source }),
      title,
      locationId: locationId,
      type: TaskCenterTypes.TaskType.TYPE_UNKNOWN,
    });
    setTaskMode('citation');
    !isTaskCenterOpen && setIsTaskCenterOpen(true);
  };

  return { setMessageCitation };
};
